import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { EmptyState, CodeSnippet } from '@backstage/core-components';

const EXAMPLE = `import { createPlugin } from '@backstage/core-plugin-api';

export default createPlugin({
  id: 'plugin-name',
  featureFlags: [{ name: 'enable-example-feature' }],
});
`;
const EmptyFlags = () => /* @__PURE__ */ React.createElement(
  EmptyState,
  {
    missing: "content",
    title: "No Feature Flags",
    description: "Feature Flags make it possible for plugins to register features in Backstage for users to opt into. You can use this to split out logic in your code for manual A/B testing, etc.",
    action: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, "An example for how to add a feature flag is highlighted below:"), /* @__PURE__ */ React.createElement(
      CodeSnippet,
      {
        text: EXAMPLE,
        language: "typescript",
        showLineNumbers: true,
        highlightedNumbers: [6],
        customStyle: { background: "inherit", fontSize: "115%" }
      }
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        variant: "contained",
        color: "primary",
        href: "https://backstage.io/docs/api/utility-apis"
      },
      "Read More"
    ))
  }
);

export { EmptyFlags };
//# sourceMappingURL=EmptyFlags.esm.js.map
